module.exports = __webpack_public_path__ + "static/img/model1.528c781.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-images/model1.png
// module id = MW7B
// module chunks = 0